import React, { Component } from "react";
import "./MAMCASurveySetting.css";
import Cookie from 'js-cookie';
import {
    message, ConfigProvider, Divider, Modal, List,
    Table, Empty, Spin, Button, Popconfirm, Row, Col
} from 'antd';
import { Link } from "react-router-dom";

export default class MAMCASurveyReceived extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: Cookie.get("email"),
            loading: true, //the loading status default true
            projectName: "",
            project: {},
            profiles: [],
            projectActor: {},
            role: "",
            intervieweeVisible: false, //for create modal
            selectedInterviewee: {},
            answerList: <span></span>
        };
    }

    //show or cancel create modal
    showIntervieweeModal = () => {
        this.setState({ intervieweeVisible: true });
    }

    handleIntervieweeCancel = () => {
        this.setState({ intervieweeVisible: false });
    }

    selectInterviewee = (record) => {
        this.setState({
            // selectInterviewee: record,
            intervieweeVisible: true
        });
        let listData = []
        record.actorQuestions.forEach(obj => {
            this.state.projectActor.actorSurveySettings.actorQuestions.forEach(q => {
                if (obj.question.toString() === q._id.toString()) {
                    listData.push({
                        title: q.question,
                        description: obj.questionAnswer
                    });
                }
            })
        })

        let ListCriteria = []
        const columns = [
            {
                title: 'Criteria Name',
                dataIndex: 'criteriaName',
                key: 'criteriaName',
            },
            {
                title: 'Weight Score',
                dataIndex: 'weightScore',
                key: 'weightScore',
            },
        ];
        if (this.state.projectActor.actorSurveySettings.actorWeightable) { //there is weight allocation
            this.state.projectActor.actorCriteria.forEach(ac => {
                let criteria = {}
                if (ac.subCriteria && ac.subCriteria.length !== 0) {
                    let children = []
                    let cData = {}
                    record.actorCriteria.forEach(c => {
                        if (c.criteria.toString() === ac._id.toString()) { //find criteria
                            cData = c
                        }
                    })
                    criteria._id = ac._id
                    criteria.criteriaName = ac.criteriaName
                    criteria.weightScore = cData.profileCriteriaWeight
                    ac.subCriteria.forEach(asc => {
                        let profileSubCriteriaWeight = 0
                        cData.subCriteria.forEach(sc => {
                            if (sc.subCriteria.toString() === asc._id.toString()) { //find criteria
                                profileSubCriteriaWeight = sc.profileSubCriteriaWeight
                            }
                        })
                        children.push({
                            _id: asc._id,
                            criteriaName: asc.subCriteriaName,
                            weightScore: profileSubCriteriaWeight
                        })
                    })
                    criteria.children = children
                    ListCriteria.push(criteria)
                }
                else {
                    let cData = {}
                    record.actorCriteria.forEach(c => {
                        if (c.criteria.toString() === ac._id.toString()) { //find criteria
                            cData = c
                        }
                    })
                    criteria._id = ac._id
                    criteria.criteriaName = ac.criteriaName
                    criteria.weightScore = cData.profileCriteriaWeight
                    ListCriteria.push(criteria)
                }
            })

        }
        let evaColumn = []
        let ListAlternatives = []
        if (this.state.projectActor.actorSurveySettings.actorEvaluatable) {
            let row = {}
            row.title = 'Alternative name'
            row.dataIndex = 'alternativeName'
            row.key = 'alternativeName'
            row.sorter = (a, b) => { if (a.alternativeName > b.alternativeName) { return -1; } if (a.alternativeName < b.alternativeName) { return 1; } return 0; }
            evaColumn.push(row)

            this.state.projectActor.actorCriteria.forEach(obj => {
                var crow = {}
                if (obj.subCriteria && obj.subCriteria[0]) { //there is subcriteria
                    crow.title = obj.criteriaName
                    var cChildren = []
                    obj.subCriteria.forEach(subObj => {
                        var subrow = {}
                        subrow.title = subObj.subCriteriaName
                        subrow.dataIndex = subObj.subCriteriaName
                        subrow.key = subObj.subCriteriaName
                        subrow.sorter = (a, b) => { if (a[subObj.subCriteriaName] > b[subObj.subCriteriaName]) { return -1; } if (a[subObj.subCriteriaName] < b[subObj.subCriteriaName]) { return 1; } return 0; }
                        cChildren.push(subrow)
                    })
                    crow.children = cChildren
                }
                else { //no suubcriteria        
                    crow.title = obj.criteriaName
                    crow.dataIndex = obj.criteriaName
                    crow.key = obj.criteriaName
                    crow.sorter = (a, b) => { if (a[obj.criteriaName] > b[obj.criteriaName]) { return -1; } if (a[obj.criteriaName] < b[obj.criteriaName]) { return 1; } return 0; }
                }
                evaColumn.push(crow)
            })

            record.profileprojectAlternatives.forEach(a => {
                let aData = {}
                this.state.project.projectAlternatives.forEach(aa => {
                    if (a.alternative.toString() === aa._id.toString()) {
                        aData.alternativeName = aa.alternativeName
                        aData._id = aa._id
                    }
                })
                a.alternativeScore.forEach(as => {
                    this.state.projectActor.actorCriteria.forEach(alac => {
                        if (alac.subCriteria && alac.subCriteria.length !== 0) {
                            alac.subCriteria.forEach(alasc => {
                                if (alasc._id.toString() === as.alternativeCriteria.toString()) {
                                    aData[alasc.subCriteriaName] = as.alternativeCriteriaScore
                                }
                            })
                        }
                        if (alac._id.toString() === as.alternativeCriteria.toString()) {
                            aData[alac.criteriaName] = as.alternativeCriteriaScore
                        }

                    })
                })
                ListAlternatives.push(aData)
            })
        }

        let answerList = (
            <span>
                <List
                    key="list"
                    itemLayout="horizontal"
                    dataSource={listData}
                    renderItem={item => (
                        <List.Item>
                            <List.Item.Meta
                                title={item.title}
                                description={item.description}
                            />
                        </List.Item>
                    )}
                />

                {this.state.projectActor.actorSurveySettings.actorWeightable ?
                    <span>
                        <Divider />

                        <Table size='small'
                            dataSource={ListCriteria}
                            columns={columns}
                            rowKey={record => record._id} />
                    </span> :
                    <span></span>}

                {this.state.projectActor.actorSurveySettings.actorEvaluatable ?
                    <span>
                        <Divider />
                        <Table size='small'
                            bordered
                            dataSource={ListAlternatives}
                            columns={evaColumn}
                            rowKey={record => record._id} />
                    </span>
                    :
                    <span></span>}

            </span>

        )


        this.setState({
            answerList: answerList
        });
    }

    //get the projects
    getProfiles = () => {
        fetch(`/project/getProfiles/${this.props.match.params.projectid}/${this.props.match.params.actorid}`, { //get the project id from link
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.setState({
                        project: json.project,
                        profiles: json.profiles,
                        projectName: json.projectName,
                        projectActor: json.projectActor,
                        role: json.role,
                        loading: false,
                    })
                }
                else {
                    message.error(json.message); //create unsuccessful, show alert
                }
            })
    }

    deleteProfile = (id) => {
        fetch('/project/deleteProfile', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: id
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getProfiles(); //if success, refresh the project list
                    message.success(json.message); //create successfully, show mesage
                }
                else {
                    message.error(json.message); //create unsuccessful, show alert
                }
            });
    }

    componentDidMount() {
        try {
            this.getProfiles() //after render immediately get alternative list
        } catch (e) {
            alert(e);
        }
    }

    render() {
        const columns = [{ //the column title of the table
            title: 'Interviewees', //the title of column
            dataIndex: 'profileOwner', //the data index can be used for searching, filtering
            key: 'profileOwner',
            // render: (text, record) => (   <Link onClick= {this.showIntervieweeModal}>{record.profileOwner}</Link> ), //make it clickable to the project
            render: (text, record) => <div style={{ cursor: "pointer" }} onClick={() => { this.selectInterviewee(record) }}>{record.profileOwner}</div>, //make it clickable to the project
            width: '80%',
        },
        {
            title: 'Actions',
            key: 'action',
            width: '20%',
            render: (text, record) => (
                <span>
                    <Popconfirm title="Are you sure you want to delete this project?" onConfirm={() => { this.deleteProfile(record._id) }} okText="Yes" cancelText="No">
                        <Link to="#">Delete</Link>
                    </Popconfirm>
                </span>
            ),
        }];
        return <div className="Alternative">
            <Spin size="large" tip="Loading..." spinning={this.state.loading}>
                <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
                    <Col span={8}>
                        <h4>Project name: {this.state.projectName}</h4>
                    </Col>
                    <Col span={8}>
                        <h4>Stakeholder group: {this.state.role}</h4>
                    </Col>
                </Row>
                <Divider />
                <div className="steps-content"></div>
                <ConfigProvider renderEmpty={() => { return (<Empty />); }}>
                    <Table columns={columns}
                        rowKey={record => record._id} //unique key needed, so we use mongodb id
                        dataSource={this.state.profiles} //the data source is what we get after component mount
                    />
                </ConfigProvider>
                <Divider />
                <div className="steps-action">
                    {/* disabled={this.checkDisable(this.state.project)} */}
                    <Button size="large" type="primary" >
                        <Link to={`/mamcasurveysetting/${this.props.match.params.projectid}`}>Back</Link></Button>
                </div>
            </Spin>
            <Modal
                visible={this.state.intervieweeVisible} //control the showing of modal
                title="Answer detail"
                onCancel={this.handleIntervieweeCancel}
                width={800}
            // onOk={onCreate}
            >
                {this.state.answerList}
            </Modal>
        </div>;
    }
}